const accentStyles = {
    indigo: "from-indigo-500 to-violet-500",
    violet: "from-violet-500 to-purple-500",
    emerald: "from-emerald-500 to-teal-500",
    sky: "from-sky-500 to-blue-500",
    amber: "from-amber-500 to-orange-500",
    rose: "from-rose-500 to-pink-500",
    slate: "from-slate-400 to-slate-500",
};

const OverviewCard = ({
    title,
    subtitle,
    children,
    className = "",
    action = null,
    accent = "indigo",
}) => {
    return (
        <div className={`relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm transition-all duration-200 hover:shadow-md ${className}`}>
            <div className={`absolute inset-x-0 top-0 h-1 bg-gradient-to-r ${accentStyles[accent] || accentStyles.indigo}`} />
            {(title || action) && (
                <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3.5">
                    <div>
                        {title && (
                            <h3 className="text-sm font-semibold text-slate-900">
                                {title}
                            </h3>
                        )}
                        {subtitle && (
                            <p className="mt-0.5 text-xs text-slate-500">
                                {subtitle}
                            </p>
                        )}
                    </div>
                    {action}
                </div>
            )}
            <div className="p-5">{children}</div>
        </div>
    );
};

export default OverviewCard;